import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/features",
    name: "Features",
    component: () =>
      import(/* webpackChunkName: "features" */ "../views/Features.vue")
  },
  {
    path: "/pricing",
    name: "Pricing",
    component: () =>
      import(/* webpackChunkName: "pricing" */ "../views/Pricing.vue")
  }
];

const router = new VueRouter({
  linkExactActiveClass: "text-primary",
  routes
});

export default router;
